import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from './instructions/instructions.component';
import { VendorService } from './shared/vendor.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'FCReferrals';
  payorkey = 0;
  headerHtml: any;
  isValidUrl = true;
  isCheckingUrl = true;
  securityCode: string = '';

  private readonly skipList = new Set<string>([
    'final','agreement','summary','particpant','validateparticipant','service',
    'questions','provider','member','referal','witness',
    'nonenumeratedprovider','nonenumeratedorganization','nonenumeratedindividual',
    'user','userdetails','user-details'
  ]);

  private navSub?: Subscription;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private vendorService: VendorService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.setHeader();
    this.navSub = this.router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) this.setHeader();
    });
  }

  ngOnDestroy(): void {
    this.navSub?.unsubscribe();
  }

  openInstruction() {
    this.modalService.open(InstructionsComponent);
  }

  setHeader() {
    this.isCheckingUrl = true;
    const url = this.router.url.split('?')[0].split('#')[0];
    const firstSeg = url.replace(/^\/+/, '').split('/')[0] || '';
    this.securityCode = firstSeg;
    if (!firstSeg) {
      this.isValidUrl = false;
      this.isCheckingUrl = false;
      this.headerHtml = '';
      return;
    }
    const loadHeaderByPayor = (payorId: number) => {
      this.vendorService.getLeadHeaders(payorId).subscribe((leadResult) => {
        if (leadResult?.HeaderText) {
          const headerHtmlText = leadResult.HeaderText
            .replace(/<img /g, '<img title="Header Image" alt="Header Image" ');
          this.headerHtml = this.sanitizer.bypassSecurityTrustHtml(headerHtmlText);
        } else {
          this.headerHtml = '';
        }
        this.isCheckingUrl = false;
      }, _ => {
        this.headerHtml = '';
        this.isCheckingUrl = false;
      });
    };
    if (this.skipList.has(firstSeg.toLowerCase())) {
      this.isValidUrl = true;
      const sessionPayorkey = parseInt(sessionStorage.getItem('payorkey') ?? '0', 10);
      if (sessionPayorkey) {
        this.payorkey = sessionPayorkey;
        loadHeaderByPayor(this.payorkey);
      } else {
        this.isCheckingUrl = false;
      }
      return;
    }
    const looksLikeCode = /^[A-Za-z0-9_-]{6,}$/.test(firstSeg);
    if (!looksLikeCode) {
      this.isValidUrl = true;
      this.isCheckingUrl = false;
      return;
    }
    this.vendorService.verifyReferralCode(this.securityCode).subscribe(confirm => {
      if (confirm) {
        this.isValidUrl = true;
        this.vendorService.getPayorIdByCode(this.securityCode).subscribe(result => {
          if (result != null) {
            this.payorkey = result;
            sessionStorage.setItem('payorkey', String(this.payorkey));
            loadHeaderByPayor(this.payorkey);
          } else {
            this.isCheckingUrl = false;
             this.isValidUrl = false;
          }
        }, _ => this.isCheckingUrl = false);
      } else {
        this.isValidUrl = false;
        this.isCheckingUrl = false;
      }
    }, _ => {
      this.isValidUrl = false;
      this.isCheckingUrl = false;
    });
  }

}
